import { useEffect, useRef, useCallback } from "react";

interface UseAutoSliderProps {
  interval?: number;
  enabled?: boolean;
  onTick?: () => void;
}

export function useAutoSlider({
  interval = 5000,
  enabled = true,
  onTick,
}: UseAutoSliderProps = {}) {
  const intervalRef = useRef<NodeJS.Timeout | null>(null);

  const startAutoplay = useCallback(() => {
    if (!enabled) return;
    if (intervalRef.current) clearInterval(intervalRef.current);

    intervalRef.current = setInterval(() => {
      if (onTick) onTick();
    }, interval);
  }, [interval, enabled, onTick]);

  const stopAutoplay = useCallback(() => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
  }, []);

  const resetAutoplay = useCallback(() => {
    stopAutoplay();
    startAutoplay();
  }, [stopAutoplay, startAutoplay]);

  useEffect(() => {
    if (enabled) startAutoplay();
    return () => stopAutoplay();
  }, [enabled, startAutoplay, stopAutoplay]);

  return {
    startAutoplay,
    stopAutoplay,
    resetAutoplay,
    isPlaying: !!intervalRef.current,
  };
}
/* -------- BANNER-SPECIFIC HOOK -------- */
export function useAutoBannerSlider(emblaRef: any, interval = 5000, enabled = true) {
  return useAutoSlider({
    interval,
    enabled,
    onTick: () => {
      if (!emblaRef?.current) return;
      const embla = emblaRef.current;
      if (!embla) return;

      if (embla.canScrollNext()) embla.scrollNext();
      else embla.scrollTo(0);
    },
  });
}
